import { useDispatch, useSelector } from 'react-redux';
import { Grid } from '@mui/material';
import { useForm } from 'react-hook-form';

import validators from 'utils/validators';
import FormCard from 'components/FormCard';
import AnimateButton from 'components/@extended/AnimateButton';
import Button from 'components/Button';
import React, { useEffect } from 'react';
import * as actions from 'reducers/produtosEtapas.reducer';
import Loader from 'components/Loader';
import MainCard from 'components/MainCard';
import { Box, Typography } from '@mui/material';
import MainLayout from 'layout/MainLayout/index';

import {
  actions as routeActions,
  types as routes
} from 'reducers/rotas.actions';
import DadosDaEtapa from './DadosDaEtapa';

const Etapa = () => {
  const dispatch = useDispatch();
  const produto = useSelector((state) => state.produtosEtapas.etapa.data);
  const produtoOperacao = useSelector((state) => state.produtos.produto.data);
  const isEditMode = useSelector(
    (state) => state.produtosEtapas.etapa.isEditMode
  );

  const disabled =
    (isEditMode && produto?.tipoSituacao !== 'A') ||
    produtoOperacao?.tipoSituacao !== 'A';

  const loading = useSelector((state) => state.produtosEtapas.etapa.loading);
  const idOperacao = useSelector((state) => state.produtosEtapas.idOperacao);

  const initialValues = {
    // Dados do Etapa
    nomeEtapa: produto?.nomeEtapa ?? '',
    ordemEtapa: produto?.ordemEtapa ?? ''
  };

  const rules = {
    // Dados do Etapa
    nomeEtapa: validators.string({ required: true }),
    ordemEtapa: validators.number({ required: true, min: 0, max: 32767 })
  };

  const formProps = {
    ...useForm(),
    rules,
    initialValues: {
      ...initialValues
    },
    defaultValues: produto
  };

  useEffect(() => {
    if (!!produto) {
      formProps.reset({
        ...produto
      });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [produto]);

  const handleSubmit = (values) => {
    const payload = {
      ...values,
      dataAlteracao: new Date().toISOString(),
      dataCriacao: new Date().toISOString(),
      idOperacao,
      tipoSituacao: 'A'
    };

    if (isEditMode) {
      dispatch(actions.editarEtapaRequest({ value: payload }));
    } else {
      dispatch(actions.criarEtapaRequest({ value: payload }));
    }
  };

  const handleGoBack = () => {
    dispatch(
      routeActions.redirectTo(routes.PRODUTO_ETAPAS, {
        idOperacao
      })
    );
  };

  if (loading) {
    return (
      <MainLayout>
        <Loader />
      </MainLayout>
    );
  }

  if (isEditMode && !produto?.idEtapa) {
    return (
      <MainLayout>
        <>
          <MainCard border={false} title={'Etapa não encontrada'}>
            <Grid
              container
              style={{ marginTop: 20, justifyContent: 'end', marginBottom: 20 }}
              spacing={2}
            >
              <Grid item xs={12} md={4}>
                <AnimateButton>
                  <Button
                    disableElevation
                    fullWidth
                    size="large"
                    type="button"
                    variant="outlined"
                    color="secondary"
                    onClick={handleGoBack}
                  >
                    VOLTAR
                  </Button>
                </AnimateButton>
              </Grid>
            </Grid>
          </MainCard>
        </>
      </MainLayout>
    );
  }

  return (
    <MainLayout>
      <form noValidate onSubmit={formProps.handleSubmit(handleSubmit)}>
        <MainCard
          contentSX={{
            paddingLeft: 1,
            paddingRight: 1
          }}
          border={false}
          title={
            !isEditMode ? (
              'Nova Etapa'
            ) : (
              <Box>
                <Typography variant="h2">{produto?.nomeEtapa}</Typography>
                <Typography variant="subtitle1" color="textSecondary">
                  Atividade
                </Typography>
              </Box>
            )
          }
        >
          <Box
            sx={{
              display: 'flex',
              flexDirection: 'column',
              justifyContent: 'space-between',
              gap: 2
            }}
          >
            <Box sx={{ flex: 1 }}>
              <FormCard title="DADOS DA ETAPA" style={{ flex: 1 }}>
                <DadosDaEtapa formProps={formProps} disabled={disabled} />
              </FormCard>
            </Box>
          </Box>
        </MainCard>

        <Grid
          container
          style={{ marginTop: 20, justifyContent: 'end', marginBottom: 20 }}
          spacing={2}
        >
          <Grid item xs={12} md={4}>
            <AnimateButton>
              <Button
                disableElevation
                fullWidth
                size="large"
                type="button"
                variant="outlined"
                color="secondary"
                onClick={handleGoBack}
              >
                VOLTAR
              </Button>
            </AnimateButton>
          </Grid>
          <Grid item xs={12} md={4}>
            <AnimateButton>
              <Button
                disabled={disabled}
                disableElevation
                fullWidth
                size="large"
                variant="contained"
                color="primary"
                type="submit"
              >
                SALVAR
              </Button>
            </AnimateButton>
          </Grid>
        </Grid>
      </form>
    </MainLayout>
  );
};

export default Etapa;
